import { Component } from "@angular/core";

@Component({
    selector: "dashboard",
    templateUrl: "dashboardPage.component.html",
    styleUrls: []
})

export class DashboardPage {

}